export const SET_DELETE_MODAL_DATA = 'SET_DELETE_MODAL_DATA' // get from api & push that to redux store

export const SET_REMOVE_FEILD_MODAL_DATA = 'SET_REMOVE_FEILD_MODAL_DATA' // get from api & push that to redux store

export const SET_SIGNATURE_MODAL_TYPE = 'SET_SIGNATURE_MODAL_TYPE'